<template>
  <div class="onboarding-form-container s-flex s-flex-col s-gap-4" :class="className">
    <!-- Header Section -->
    <slot name="header">
      <div class="s-flex s-flex-col s-items-start">
        <div class="header s-text-xl s-font-semibold">
          {{ title }}
        </div>
        <div class="subtitle s-text-sm s-text-neutral-400">
          {{ description }}
        </div>
      </div>

      <s-notification
        v-if="prefilled"
        variant="primary"
        width="full"
        class="s-text-left s-text-sm"
      >
        Some field are pre-filled from Chargebee Billing. Review and make corrections if necassary.
      </s-notification>
      <div class="separator"></div>
    </slot>

    <slot></slot>

    <s-notification v-if="errors.length" variant="danger" width="full">
      <ul v-if="errors.length">
        <li v-for="(error, index) in errors" :key="index">
          {{ error }}
        </li>
      </ul>
    </s-notification>
    
    <!-- Action Buttons -->
    <div class="s-w-full s-flex s-justify-end s-mt-4 s-gap-4">
      <slot name="actions">
        <s-button
          v-if="showPrevious"
          variant="neutral"
          size="large"
          :disabled="loading"
          @click="$emit('previous')"
        >
          {{ $t('global.action.previous') }}
        </s-button>

        <s-button
          variant="primary"
          size="large"
          :loading="loading"
          :disabled="disableProceed"
          @click="$emit('proceed')"
        >
          {{ $t(proceedLabel) }}
        </s-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingFormLayout',
  props: {
    title: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    prefilled: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    showPrevious: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    proceedLabel: {
      type: String,
      default: "global.action.proceed"
    },
    disableProceed: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss">
.onboarding-form-container {
  .separator {
    background-color: $divider_color;
    height: 1px;
    width: 100%;
  }

  .s-selectmenu-content {
    min-width: auto;
  }
}
</style>
